import React from 'react';
import classNames from 'classnames';
import { t } from '../../../../../i18n';
import './styles.scss';

const RedeemStatus = ({ redeemStatus, className }) => {
  if (!redeemStatus) {
    return null;
  }
  const { loading, error, success } = redeemStatus;

  if (loading) {
    return (
      <div
        className={classNames(
          'course-gift-card-redeem__activation-status',
          'course-gift-card-redeem__activation-status--loading',
          'placeholder-glow',
          className,
        )}
      >
        <div className="placeholder" />
      </div>
    );
  }

  if (error) {
    return (
      <p
        className={classNames(
          'course-gift-card-redeem__activation-status',
          'course-gift-card-redeem__activation-status--error',
          className,
        )}
      >
        {t(error)}
      </p>
    );
  }

  if (success) {
    return (
      <p
        className={classNames(
          'course-gift-card-redeem__activation-status',
          'course-gift-card-redeem__activation-status--success',
          className,
        )}
      >
        {t('DIGITAL_COURSES.GIFT_CARD_REDEEM.CODE_IS_VALID')}
      </p>
    );
  }

  return null;
};

export default RedeemStatus;
